export function buildCommonContext(globalContextManager, userContextManager, accountContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        account: accountContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
